export enum ComTransmittedStatus {
    DONE = 0, //Message envoyé avec success
    WAIT = 1, //En attente de la réponse API
    ERROR = 2, //Erreur
    NONE = 3, //Pas de message envoyé
    ERROR_RETRY = 4, //Erreur qu'on peut retry
    HELD = 5 //Message retenu, on peut retry
}